import produce from 'immer';

import {
  CREATE_WEBHOOK_FAILURE,
  CREATE_WEBHOOK_SUCCESS,
  DELETE_WEBHOOK_FAILURE,
  DELETE_WEBHOOK_SUCCESS,
  EDIT_WEBHOOK_FAILURE,
  EDIT_WEBHOOK_SUCCESS,
  GET_WEBHOOK_FAILURE,
  GET_WEBHOOK_LIST_FAILURE,
  GET_WEBHOOK_LIST_SUCCESS,
  GET_WEBHOOK_SUCCESS,
  TEST_WEBHOOK_FAILURE,
  TEST_WEBHOOK_SUCCESS,
} from '@actions/webhook';

const initialState: IWebhookStore = {
  currentWebhook: null,
  webhooks: null,
  testResponse: null,
  error: null,
};

export default (state: IWebhookStore = initialState, action: any) =>
  produce(state, (draftState: IWebhookStore) => {
    switch (action.type) {
      case CREATE_WEBHOOK_SUCCESS:
      case EDIT_WEBHOOK_SUCCESS:
      case GET_WEBHOOK_SUCCESS:
        draftState.currentWebhook = action.response;
        draftState.error = null;

        return;

      case CREATE_WEBHOOK_FAILURE:
      case EDIT_WEBHOOK_FAILURE:
      case GET_WEBHOOK_LIST_FAILURE:
      case DELETE_WEBHOOK_FAILURE:
        draftState.error = action.error;

        return;

      case GET_WEBHOOK_FAILURE:
        draftState.currentWebhook = null;
        draftState.error = action.error;

        return;

      case GET_WEBHOOK_LIST_SUCCESS:
      case DELETE_WEBHOOK_SUCCESS:
        draftState.webhooks = action.response;
        draftState.error = null;

        return;

      case TEST_WEBHOOK_SUCCESS:
        draftState.testResponse = action.response;
        draftState.error = null;

        return;

      case TEST_WEBHOOK_FAILURE:
        draftState.testResponse = null;
        draftState.error = action.error;
    }
  });
